import type {AppProfile, AppSpec, AppStruct, ConnectorStruct} from '@cohort/shared/schema/apps/app';
import type {OAuth2AppCredentials, OAuth2Credentials} from '@cohort/shared/schema/apps/oauth';
import {
  basicOauth2ConnectorSpec,
  OAuth2AppCredentialsSchema,
} from '@cohort/shared/schema/apps/oauth';

export type YoutubeConnectorStruct = ConnectorStruct<
  'youtube',
  OAuth2Credentials,
  AppProfile,
  null
>;

export type YoutubeAppStruct = AppStruct<
  'youtube',
  OAuth2AppCredentials,
  null,
  YoutubeConnectorStruct,
  null,
  never,
  never,
  never,
  never,
  never
>;

export const YoutubeConnectorSpec = basicOauth2ConnectorSpec<YoutubeConnectorStruct>('youtube');

export const YoutubeAppSpec: AppSpec<YoutubeAppStruct> = {
  id: 'youtube',
  name: 'Youtube',
  appCredentialsSchema: OAuth2AppCredentialsSchema,
  merchantConnector: null,
  userConnector: YoutubeConnectorSpec,
  usersSyncSpec: null,
  actionSpecs: [],
  notificationIntegrationSpecs: [],
  perkIntegrationSpecs: [],
  triggerIntegrationSpecs: [],
  userEventSpecs: [],
};
